import {
    AuthorizationCodeExpired,
    getLinkedinCredential,
    loadLearningRouteCertificates,
    loadOrganization,
} from '../interact.jsx';
import { useQuery } from '@tanstack/react-query';

export const useLinkedinCredential = (authorizationCode, onSuccess, onError) => {
    return useQuery({
        queryKey: ['authorizationCode', authorizationCode],
        queryFn: () =>
            getLinkedinCredential(authorizationCode)
                .then((credential) => {
                    onSuccess();
                    return credential;
                })
                .catch((e) => {
                    if (e instanceof AuthorizationCodeExpired) {
                        onError();
                    }
                    return {};
                }),
        retry: false,
    });
};

export const LoadOrganization = (minter) => {
    return useQuery({
        queryKey: ['organization', minter],
        queryFn: () => loadOrganization(minter),
        refetchOnMount: false,
        staleTime: 'Infinity',
    });
};

export const LoadLearningRouteCertificates = (certificate, learningRoute) => {
    return useQuery({
        queryKey: ['learningRoute', certificate],
        queryFn: () => loadLearningRouteCertificates(certificate, learningRoute),
        refetchOnMount: false,
    });
};
